import axios from 'axios'
import router from '@/router'

const state = {
    idToken: localStorage.getItem('token') || null,
    userId: null,
    user: null,
    settings: {
        background_color: "#f1f3f4",
        primary_color: "#007bff",
        secondary_color: "#545b62"
    }
}

const mutations = {
    'AUTH_USER'(state, userData) {
        state.idToken = userData.token
        // state.userId = userData.userId
    },
    'STORE_USER'(state, user) {
        state.user = user
    },
    'CLEAR_AUTH_DATA'(state) {
        state.idToken = null
        state.userId = null
    },
    'GET_USER_DATA'(state, user) {
        let countries = [{
            id: 0,
            name: 'Overview',
            value: '',
            checked: true
        }]
        //Countries array formatten in goed formaat
        for (var key in user.countries) {
            countries.push({
                id: user.countries[key].id,
                name: user.countries[key].name,
                value: user.countries[key].value,
                checked: false
            })
        }

        let sources = []
        //Sources array formatten in goed formaat
        for (var key2 in user.sources) {
            sources.push({
                name: user.sources[key2],
            })
        }

        let contacts = []

        for (var key3 in user.contacts){
            contacts.push({
                id: key3,
                name: user.contacts[key3]
            })
        }

        // let sales = []
        // //Sales array formatten in goed formaat
        // for (var key in user.sales.overview) {
        //     sales.push({
        //         name: user.sales.overview[key],
        //     })
        // }
        // let salesReturn = {overview: sales, by_country: user.sales.by_country}

        state.user = {
            user: user.user,
            countries: countries,
            roles: user.roles,
            sales: user.sales,
            contacts: contacts,
            sources: sources
        }
    },
    'UNCHECK_ALL_COUNTRIES'(state) {
        for (var key in state.user.countries) {
            if (state.user.countries[key].value !== '') {
                state.user.countries[key].checked = false
            }
        }
    },
    'UNCHECK_OVERVIEW'(state) {
        for (var key in state.user.countries) {
            if (state.user.countries[key].value === '') {
                state.user.countries[key].checked = false
            }
        }
    },
    'CHECK_OVERVIEW'(state) {
        state.user.countries[0].checked = true
    }
}

const actions = {
    //Login functie
    login({commit}, authData) {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_URL + 'login', {
                email: authData.email,
                password: authData.password
            }).then((res) => {
                const expiresAt = res.data.success.expires_at
                const accessToken = res.data.success.token

                localStorage.setItem('token', accessToken)
                localStorage.setItem('expirationDate', expiresAt)
                commit('AUTH_USER', {
                    token: accessToken
                })
                // dispatch('userData')
                resolve(res)
            }).catch(error => {
                reject(error.response.data)
            })
        })
    },
    //Default data ophalen na inlog
    userData: async ({commit, state}) => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.idToken
        return axios.get(process.env.VUE_APP_API_URL + 'data')
            .then((res) => {
                commit('GET_USER_DATA', res.data)
                return true
            })
            //Opnieuw inloggen bij verkeerde token, bv aanmaken in localstorage
            .catch(() => {
                localStorage.removeItem('expirationDate')
                localStorage.removeItem('token')
                localStorage.removeItem('userId')
                state.idToken = null
                state.userId = null
                return false
            })
    },
    //Logout functie
    destroyToken(context) {
        if (context.getters.isAuthenticated) {
            return new Promise((resolve, reject) => {
                axios.get(process.env.VUE_APP_API_URL + 'logout')
                    .then((res) => {
                        localStorage.removeItem('expirationDate')
                        localStorage.removeItem('token')
                        localStorage.removeItem('userId')
                        context.commit('CLEAR_AUTH_DATA')
                        router.push({name: 'login'})
                        resolve(res)
                    })
                    .catch(error => {
                        localStorage.removeItem('expirationDate')
                        localStorage.removeItem('token')
                        localStorage.removeItem('userId')
                        reject(error)
                    })
            })
        }
    },
    //Bij 401 (unauthorized), token enzo leegmaken
    interceptToken(context) {
        localStorage.removeItem('expirationDate')
        localStorage.removeItem('token')
        localStorage.removeItem('userId')
        context.commit('CLEAR_AUTH_DATA')
        router.push({name: 'login'})
    },
    uncheckAllCountries(context) {
        context.commit('UNCHECK_ALL_COUNTRIES')
    },
    uncheckOverview(context) {
        context.commit('UNCHECK_OVERVIEW')
    },
    checkOverview(context) {
        context.commit('CHECK_OVERVIEW')
    },
    //Password email link request
    PASSWORD_FORGOT(context, authData) {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_URL + 'password/email', {
                email: authData.email
            }).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error.response.data)
            })
        })
    },
    //New password set
    PASSWORD_RESET(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_URL + 'password/reset', {
                email: payload.email,
                token: payload.token,
                password: payload.password,
                password_confirmation: payload.password_confirmation
            }).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error.response.data)
            })
        })
    },
}

const getters = {
    USER(state) {
        return state.user
    },
    isAuthenticated(state) {
        return state.idToken !== null
    },
    ROLES(state) {
        if(state.user.user.roles[0]){
            return state.user.user.roles[0].name
        }else{
            return null
        }

    },
    SETTINGS(state) {
        return state.settings
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}
